import React from "react";
import InfiniteScrollComponent from "../../../../../../components/Common/InfiniteScroll/InfiniteScrollComponent";
import Loader from "../../../../../../components/Common/Loader/Loader";
import ClassList from "./ClassList";
import classes from "./ManageClasses.module.scss";

const ManageClasses = ({
  classDetails,
  radioBtnVal,
  repititiveValArr,
  classDetailsLoader,
  fetchMoreData,
  hasMoreData,
  totalRows,
  setValue,
  getUserGroupMandateShotClasses,
  selectVal,
  getValues,
}) => {
  return (
    <div className={classes.manageClass}>
      {totalRows >= 6 ? (
        <InfiniteScrollComponent
          dataLength={classDetails?.length ? classDetails.length : 10}
          fetchMoreData={fetchMoreData}
          hasMoreData={hasMoreData}
          height={"100vh"}
          loader={true}
        >
          <ClassList
            radioBtnVal={radioBtnVal}
            repititiveValArr={repititiveValArr}
            classDetails={classDetails}
            setValue={setValue}
            getUserGroupMandateShotClasses={getUserGroupMandateShotClasses}
            selectVal={selectVal}
            getValues={getValues}
          />
        </InfiniteScrollComponent>
      ) : (
        <ClassList
          radioBtnVal={radioBtnVal}
          repititiveValArr={repititiveValArr}
          classDetails={classDetails}
          setValue={setValue}
          getUserGroupMandateShotClasses={getUserGroupMandateShotClasses}
          selectVal={selectVal}
          getValues={getValues}
        />
      )}
      {classDetails?.length === 0 && !classDetailsLoader && (
        <div className={classes.noRecordFound}>No Classes Found</div>
      )}
      {classDetailsLoader && classDetails?.length === 0 && (
        <div className={classes.loader}>
          <Loader height="50" width="50" />
        </div>
      )}
    </div>
  );
};

export default ManageClasses;
